import { GenericInputProps } from 'components/ui/GenericInput';
import { ProcessFormTemplateField } from 'types/dataCaptureTypes';

export interface InputType {
  id: string;
  name: string;
  description: null;
  isInitiating: boolean;
  isRepeatable: boolean;
  positionX: number;
  positionY: number;
  status: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface EditProcessBlockForm {
  name: string;
  description: string;
  inputs: string;
  processType: string;
  isEndOfFlow?: boolean;
  isInitOfFlow?: boolean;
}

export interface EditProcessBlockPayload {
  name?: string;
  description?: string;
  isEndOfFlow?: boolean;
  isInitOfFlow?: boolean;
  externalCode?: number;
}

export type ProcessesBlockInputProps = Array<
  Omit<GenericInputProps<EditProcessBlockForm>, 'control' | 'errors'>
>;

export interface OutPutCellReport {
  processMapId: string;
  processMapName: string;
  transactionId: string;
  processId: string;
  processName: string;
  traceabilityId: string;
  transactionDate: string;
  location: string;
  productId: string;
  product: string;
  quantity: number;
  unitOfMeasure: string;
  balance: number;
}
export interface TransactionGroupDto {
  sourceBlockName: string;
  targetBlockName: string;
  canDisconnect: boolean;
  connectionId: string;
  transactions: OutPutCellReport[];
  total: number;
  page: number;
  limit: number;
}

export interface OutputCellResponse {
  outputCellId: string;
  transactionGroups: TransactionGroupDto[];
}

export interface OutputCellConnection {
  connectionId: string;
  sourceBlockName: string;
  targetBlockName: string;
  canDisconnect: boolean;
}

export interface OutputCellConnectionsResponse {
  outputCellId: string;
  connections: OutputCellConnection[];
}


export enum ConfigurationTabs {
  FormCapture = 'form-capture',
  FlatFile = 'flat-file',
}

export interface TraceabilityPlan {
  id: string;
  name: string;
  description: string | null;
  status: string;
  createdAt: string;
  updatedAt: string;
  createdBy: {
    id: string;
    email: string;
    walletId: string;
    firstName: string;
    lastName: string;
    countryCode: string | null;
    phoneCode: string;
    phoneNumber: string;
    language: string | null;
    timeZone: string | null;
    imageUrl: string | null;
    createdAt: string;
    updatedAt: string;
  };
  externalCode: number | null;
}

export interface Process {
  id: string;
  name: string;
  description: string | null;
  regulationYear: string | null;
  isActive: boolean;
  displayOrder: number | null;
  icon: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ProcessFlow {
  id: string;
  name: string | null;
  description: string | null;
  isInitiating: boolean;
  isRepeatable: boolean;
  positionX: number;
  positionY: number;
  isEndOfFlow: boolean;
  isInitOfFlow: boolean;
  status: string;
  deleted: boolean;
  createdAt: string;
  updatedAt: string;
  type: string;
  externalCode: number | null;
  plan: TraceabilityPlan;
  process: Process;
}

export interface FieldResponse {
  id: string;
  name: string;
  is_custom: boolean;
  field_key: string | null;
  display_order: number;
  metadata: {
    field_name?: string;
    is_required?: {
      value: boolean;
      read_only: boolean;
    };
    is_visible?: {
      value: boolean;
      read_only: boolean;
    };
    flow_through?: {
      value: boolean;
      read_only: boolean;
    };
    system_generated: {
      value: boolean;
      read_only: boolean;
    };
    accepted_values?: {
      value: string[];
      read_only: boolean;
    };
    default_values?: {
      value: string;
      read_only: boolean;
    };
    field_type: string;
    capture_type: string;
    is_editable: boolean;
  };
}

export interface ProcessFormWithFieldsResponse {
  form_id: string;
  form_name: string;
  description?: string;
  fields: ProcessFormTemplateField[];
  templateId?: string;
  userIds?: string[];
}

export interface ProcessBlockData extends ProcessFlow {
  inputs: ProcessFlow[];
  processForm?: ProcessFormWithFieldsResponse;
}
